import AOS from "aos";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import BrandsMarqueSection from "../../../common/BrandsMarqueSection";
import Footer from "../../../common/Footer";
import Header from "../../../common/Header";
import Loader from "../../../common/Loader";
import ProgressCircle from "../../../common/ProgressCircle";
import TextMarqueSection from "../../../common/TextMarqueSection";
import PortfolioSection from "../Index";

const Portfolio = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  const location = useLocation();
  const [activeItem, setActiveItem] = useState("/");
  const [isFixed, setIsFixed] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [subActiveIndex, setSubActiveIndex] = useState(null);

  useEffect(() => {
    setActiveItem(location.pathname);
  }, [location.pathname]);

  const isActive = (path) => (activeItem === path ? "menu-active" : "");

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    if (scrollPosition >= 20) {
      setIsFixed(true);
    } else {
      setIsFixed(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
    setSubActiveIndex(null); // Reset sub menu when main menu is toggled
  };

  const toggleSubAccordion = (index) => {
    setSubActiveIndex(subActiveIndex === index ? null : index);
  };
  return (
    <>
      <Helmet>
        <title>Portfolio | Marichi Tech AI</title>
        <meta
          name="description"
          content="Check out our recent projects in web, mobile, and cloud development."
        />
        <meta
          name="keywords"
          content="Portfolio, IT projects, case studies, software solutions"
        />
        <meta property="og:title" content="Portfolio | Marichi Tech AI" />
        <meta
          property="og:description"
          content="Explore our successful collaborations and digital solutions."
        />
        <meta
          property="og:image"
          content="https://example.com/portfolio-og-image.jpg"
        />
      </Helmet>

      <Loader />
      <div className="site_contain">
        {/* <!-- ====================================== Header Menu ===================================== --> */}

        <Header />

        {/* <!-- ====================================== Header Menu End===================================== --> */}
        {/* <!-- ====================================== Portfolio Section One ===================================== --> */}
        {/* <SectionOne /> */}
        {/* <!-- ====================================== Portfolio Section One End ===================================== --> */}
        {/* <!-- ====================================== Latest Project Images ===================================== --> */}
        <PortfolioSection />
        {/* <!-- ====================================== Latest Project Images ===================================== --> */}
        {/* <!-- ====================================== Brands Marquee Section Start ===================================== --> */}
        <BrandsMarqueSection />
        {/* <!-- ====================================== Brands Marquee Section End ===================================== --> */}
        <TextMarqueSection />
        {/* <!-- ====================================== text Marquee Section End ===================================== --> */}
        {/* <!-- ====================================== Footer ===================================== --> */}
        <Footer />
        {/* <!-- ====================================== Progress Scroll Bottom To Top ===================================== --> */}
        <ProgressCircle />
        {/* <!-- ====================================== Progress Scroll Bottom To Top End ===================================== --> */}
      </div>
    </>
  );
};
export default Portfolio;
